/* eslint-disable complexity */

/**
 * @description - Get  base url
 * @param {*} hostName - Endpoint.
 * @returns {*} - Base url with endp point.
 */
 export function getCurrentEnv(hostName) {
    const key = hostName.split('.')[0];
    switch (key) {
      case 'localhost':
        return 'local'; // localHost
      case 'stag':
        return 'stag'; // staging env
      case 'vops':
        return 'vops'; // Production env
      default:
        return 'vops';
    }
  }
  
  /**
   * @description - Get base url with end point.
   * @param {*} flag - Endpoint.
   */
  export function isValidEnv(flag) {
    const { hostname } = window.location;
    const envKey = getCurrentEnv(hostname);
    const featureValidation = flag[envKey];
    return featureValidation;
  }
  


// WEBPACK FOOTER //
// ./src/utils/featureFlagEnv.js